/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';
import Photo from '@components/global/Photo';
import TitleSubSection from '@components/global/TitleSubSection';
import SociollaText from '@components/sociolla/SociollaText';
import ScrollContainer from '@components/global/ScrollContainer';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import Table from '@components/table/Table';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.array,
};

const defaultProps = {
  data: [],
};

const photoSize = 35;

const TeamMemberDefault = (props) => {
  const { data: lists } = props;

  const tableStructure = {
    name: {
      head: 'Name',
      body: 'name',
      type: 'slot',
      textStyle: { fontSize: 13, fontFamily: 'figtree-medium' },
    },
    sales_team: {
      head: 'Sales Team',
      body: 'sales_team',
    },
    role: {
      head: 'Role',
      body: 'role',
    },
  };

  let tableData = [];
  if (lists && lists.length) {
    tableData = lists.map((item) => {
      return {
        name: item.name,
        image: item.image ? item.image : '',
        sales_team: item.sales_team ? item.sales_team : '',
        role: item?.role?.name ? item.role.name : '',
      };
    });
  }

  const Team = ({ item, index }) => {
    return (
      <View
        key={index}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          ...(!isWeb
            ? {
                width: '100%',
                paddingHorizontal: 15,
                paddingVertical: 12,
                borderBottomWidth: 1,
                borderBottomColor: Colors.grey0,
                ...(index == 0
                  ? {
                      borderTopColor: Colors.grey0,
                      borderTopWidth: 1,
                    }
                  : {}),
              }
            : {}),
        }}>
        <Photo width={photoSize} height={photoSize} image={item.image} />
        <View>
          <SociollaText type="medium">{item.name}</SociollaText>
          {!isWeb ? (
            <SociollaText style={{ color: Colors.grey1, marginTop: 5 }}>
              {item?.role ? `${item.role} - ` : ''}
              {item.sales_team ? item.sales_team : ''}
            </SociollaText>
          ) : (
            false
          )}
        </View>
      </View>
    );
  };

  return isWeb ? (
    <>
      <TitleSubSection title="TEAM MEMBERS" />
      <View
        style={{
          width: '100%',
          backgroundColor: Colors.white,
          paddingHorizontal: 10,
          paddingBottom: 15,
        }}>
        <Table
          structures={tableStructure}
          data={tableData}
          hasCallback={true}
          hasNoHide={true}
          showFilter={false}
          noTopSection={true}
          showPagination={false}
          withoutShadow={true}
          slot={{
            name: ({ data, index }) => (
              <Team item={data} index={index} key={index} />
            ),
          }}
        />
      </View>
    </>
  ) : (
    <ScrollContainer>
      {tableData.map((item, index) => (
        <Team item={item} index={index} key={index} />
      ))}
    </ScrollContainer>
  );
};

TeamMemberDefault.propTypes = propTypes;
TeamMemberDefault.defaultProps = defaultProps;

export default TeamMemberDefault;
